import { render } from "./SortingIcon.vue?vue&type=template&id=1f29dadc"
import script from "./SortingIcon.vue?vue&type=script&lang=js"
export * from "./SortingIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__